import { useMutation, useQueryClient } from "react-query";
import { EStudentProgressQueryKeys } from "api/endpoints/student-progress";
import {
  moveHistoriesToClass,
  moveHistoriesToHomework,
} from "api/services/student-progress";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import { TUrlParam } from "types/utils";

type TBatchMovePayload = {
  historyIds: number[];
  homework: boolean;
};

export const useBatchMoveExercises = (
  studentId: TUrlParam,
  courseId: TUrlParam,
  lessonId: TUrlParam
) => {
  const queryClient = useQueryClient();

  return useMutation<unknown, TApiError, TBatchMovePayload>(
    ({ historyIds, homework }) =>
      homework
        ? moveHistoriesToHomework(studentId, courseId, lessonId, historyIds)
        : moveHistoriesToClass(studentId, courseId, lessonId, historyIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          EStudentProgressQueryKeys.getChapterStudentProgress,
          courseId,
          lessonId,
        ]);
      },
      onError: (error) => logError({ error }),
    }
  );
};
